import styled from "styled-components";
import { Message } from "../message/Message";
import { ContentsNotification } from "./ContentsNotification";
import { SideBarNotifications } from "./SideBarNotifications";

export const Notification = () => {
    return (
        <PageWrapper>
            <Container>
                <SideBarNotifications />
                <ContentsNotification />
                <Message />
            </Container>
        </PageWrapper>
    );
};

const PageWrapper = styled.div`
    min-height: 100vh;
    background-color: var(--primary-base-cream);
    padding: 1.5rem 0;
`;

const Container = styled.div`
    display: flex;
    max-width: 1000px;
    width: 100%;
    margin: 0 auto;
    gap: 16px;
    padding: 0 1rem;

    & > * {
        background-color: #ffffff;
        border-radius: 8px;
        border: 1px solid rgba(201, 160, 99, 0.2);
        box-shadow: 0 2px 8px rgba(10, 20, 40, 0.06);
    }
`;
